import { Component } from '@angular/core';

@Component({
  selector: 'app-congrat-signup',
  standalone: false,
  templateUrl: './congrat-signup.component.html',
  styleUrl: './congrat-signup.component.scss'
})
export class CongratSignupComponent {

}
